import './StaticPage.css';

export default function StaticPage({ title, updated, children }) {
  return (
    <div className="static-page">
      <div className="container static-page-inner">
        <h1 className="font-display static-title">{title}</h1>
        {updated && <p className="static-updated">Last updated: {updated}</p>}
        <div className="static-content">{children}</div>
      </div>
    </div>
  );
}
